import { createAction } from 'typesafe-actions';

export const setLoading = createAction('SET_LOADING', (value: boolean) => value)<boolean>();
export const setLocalLoading = createAction('SET_LOCAL_LOADING', (value: string | null) => value)<string>();
